import React from 'react';
import { Box, Container } from '@mui/material';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import useStyles from './styles';
import CFDIIncomeTabs from './CFDIIncomeListTabs';

const CFDIIncomeListView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.ContainerRoot} title={t('NAVIGATION.CFDI_INCOME')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <CFDIIncomeTabs />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default CFDIIncomeListView;
